import { render, staticRenderFns } from "./Lecture.vue?vue&type=template&id=5c033cf0&"
import script from "./Lecture.vue?vue&type=script&lang=js&"
export * from "./Lecture.vue?vue&type=script&lang=js&"
import style0 from "./Lecture.vue?vue&type=style&index=0&lang=css&"
import style1 from "./Lecture.vue?vue&type=style&index=1&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports